import { type RolePermissions } from "enums";
import Restricted from "features/Application/Restricted";
import BasicLinkButton from "../baseLinkButton/BasicLinkButton";
import styles from "./ToggleVisibilityButton.module.scss";
import { Tooltip } from "components/common/tooltip";
import { Icon } from "semantic-ui-react";

interface Props {
  onClick: () => void;
  isDisabled?: boolean;
  hidden: boolean;
  requiredPermissions?: RolePermissions[];
}

export const ToggleVisibilityButton = (props: Props) => {
  const { onClick, isDisabled, hidden, requiredPermissions } = props;

  const renderButton = () => (
    <Tooltip
      showAlways={isDisabled}
      inverted
      hideOnScroll
      position="left center"
      content="Selection contains either unpublished and published, or shown and hidden content."
      target={
        <div style={{ display: "flex", alignItems: "center" }}>
          <BasicLinkButton
            text={hidden ? "Show" : "Hide"}
            iconClassName={hidden ? "fa-regular fa-eye" : "fa-solid fa-eye-slash"}
            onClick={onClick}
            isDisabled={isDisabled}
            className={styles.root}
          />
          {isDisabled && <Icon size="large" className="fa fa-exclamation-circle" />}
        </div>
      }
    />
  );

  return requiredPermissions ? (
    <Restricted permissions={requiredPermissions}>{renderButton()}</Restricted>
  ) : (
    renderButton()
  );
};
